import { Pipe, PipeTransform } from '@angular/core';
import { Region } from '../../models/region';

@Pipe({
	name: 'filterRegionByName'
})
export class FilterRegionByNamePipe implements PipeTransform {
	transform(region: Region[], filter: string): Region[] {
		if (
			!region ||
			!filter ||
			region === null ||
			filter === null ||
			filter === ''
		) {
			return region;
		}

		return region.filter((region: Region) => {
			if (region.name) {
				// TODO: add lastName too
				return region.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
